package com.voter.models

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
data class VotingOption(
    val id: String,
    val title: String,
    val description: String? = null,
    val url: String? = null,
    val imageUrl: String? = null,
    val processedImagePath: String? = null, // Path to processed image file
    val quickFacts: Map<String, String> = emptyMap() // Key-value pairs for quick facts
)

@Serializable
data class Vote(
    val voterName: String,
    val voterIp: String,
    val userAgent: String,
    val timestamp: Instant,
    val ratings: Map<String, Int> // optionId to rating (0-5)
)

@Serializable
enum class PollStatus {
    NOT_STARTED,
    IN_PROGRESS,
    ENDED
}

@Serializable
data class Poll(
    val id: String,
    val title: String,
    val description: String? = null,
    val options: List<VotingOption>,
    val status: PollStatus = PollStatus.NOT_STARTED,
    val createdBy: String, // IP + User Agent hash
    val createdAt: Instant,
    val votes: List<Vote> = emptyList()
)

@Serializable
data class CreatePollRequest(
    val title: String,
    val description: String? = null,
    val options: List<VotingOption>
)

@Serializable
data class VoteRequest(
    val voterName: String,
    val ratings: Map<String, Int>
)

@Serializable
data class PollStatusResponse(
    val poll: Poll,
    val voterNames: List<String>? = null,
    val results: PollResults? = null
)

@Serializable
data class PollResults(
    val winner: VotingOption,
    val winnerPreferenceCount: Int,
    val averageRatings: Map<String, Double>
)
